<template>
  <v-card
    class="routine-card pl-4 pr-2 py-1  d-flex justify-space-between"
    color="white"
    height="75"
    elevation="0"
    :class="isSelected ? 'selected' : 'card-border'"
    :ripple="false"
    @click="$emit('selectTemplate')"
  >
    <div class="d-flex flex-column justify-center align-start mw-0 w-100">
      <v-tooltip top max-width="300">
        <template v-slot:activator="{ on }">
          <p
            v-on="on"
            class="routine-card__name subtitle2 font-weight-medium mb-2"
            :class="
              isSelected ? 'white--text' : 'blue-grey--text text--darken-3'
            "
          >
            <text-highlight
              highlightClass="yellow lighten-1"
              highlightComponent="span"
              :queries="searchHighlights"
              :title="routine.name"
            >
              {{ routine.name }}
            </text-highlight>
          </p>
        </template>
        <p>
          {{ routine.name }}
        </p>
      </v-tooltip>
      <div class="d-flex justify-space-between align-center w-100">
        <div class="d-flex">
          <div v-if="routine.type" class="d-flex align-center">
            <v-icon small :color="isSelected ? 'white' : 'blue-grey'">
              mdi-clipboard-text-outline
            </v-icon>
            <p
              class="button-text font-weight-medium font-size-12 mb-0 ml-1 mr-2"
              :class="isSelected ? 'white--text' : 'blue-grey--text'"
            >
              {{ $t(`routines.type.${routine.type}`) }}
            </p>
          </div>

          <div class="d-flex align-center">
            <v-icon small :color="isSelected ? 'white' : 'blue-grey'">
              mdi-warehouse
            </v-icon>
            <p
              class="button-text font-weight-medium font-size-12 mb-0 ml-1"
              :class="isSelected ? 'white--text' : 'blue-grey--text'"
            >
              {{ siteName }}
            </p>
          </div>
        </div>
        <p @click.stop.prevent="$emit('showChecklist')" class="button-text ">
          <span :class="isSelected ? 'white--text' : 'blue--text'">
            {{ $t('common.button.view_details') }}
          </span>
        </p>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'NewTemplateCard',

  props: {
    routine: {
      type: Object,
      required: true,
    },

    searchHighlights: {
      type: Array,
      default: () => [],
    },

    isSelected: Boolean,
  },

  computed: {
    siteName() {
      return this.routine.site?.name ?? ''
    },
  },
}
</script>

<style lang="scss" scoped>
.card-border {
  border: 1px solid $color-blue-grey-lighten2 !important;
  background-color: white !important;
  transition: 0.2s ease;
  &:hover {
    box-shadow: inset 0 0 0 2px $color-blue !important;
    transition: 0.2s ease;
    border: 1px solid transparent !important;
  }

  &::before {
    background: white !important;
  }
}

.selected {
  transition: 0.2s ease;
  &::before {
    transition: 0.2s ease;
    border-radius: 4px !important;
    opacity: 1 !important;
    background: $color-blue !important;
  }
}

.routine-card {
  transition: 0.2s ease;
  background-color: white !important;
  &:hover {
    transition: 0.2s ease;
  }
}

.routine-card__name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 260px;
  z-index: 1;
}

.button-text {
  z-index: 1;
}
</style>
